// ConditionsGenerales.jsx
import React from "react";
import "./privacy-policy.css"; // reuse the same CSS as the English pages
import Navbar from "./Navbar";

const ConditionsGenerales = () => {
  return (
    <>
      <Navbar />
      <main className="policy">
        <div className="policy__inner">
          <header className="policy__header">
            <h1 className="policy__title">Conditions Générales d’Utilisation</h1>
            <p className="policy__updated">
              Dernière mise à jour : <strong>1er septembre 2025</strong>
            </p>
          </header>

          <p className="policy__lead">
            Bienvenue chez <span className="accent">FlxDeck</span>. En accédant à notre site web et à nos services, vous acceptez les présentes Conditions Générales d’Utilisation. Veuillez les lire
            attentivement.
          </p>

          <section className="policy__section">
            <h2>1. Acceptation des conditions</h2>
            <p>
              En utilisant notre site web ou en soumettant le formulaire de partenariat, vous confirmez être autorisé à représenter votre salle de sport ou votre entreprise et vous acceptez ces
              conditions.
            </p>
          </section>

          <section className="policy__section">
            <h2>2. Utilisation des services</h2>
            <p>
              FlxDeck fournit des informations sur notre solution de borne interactive pour salles de sport. Vous vous engagez à ne pas faire un usage abusif de notre site ou de nos services, y
              compris toute tentative de perturber ou d’interférer avec nos systèmes.
            </p>
          </section>

          <section className="policy__section">
            <h2>3. Demandes de partenariat</h2>
            <p>
              En remplissant le formulaire de partenariat, vous acceptez de fournir des informations exactes et complètes. Notre équipe examinera votre demande et vous contactera pour définir les
              prochaines étapes. Nous nous réservons le droit de refuser toute demande de partenariat à notre seule discrétion.
            </p>
          </section>

          <section className="policy__section">
            <h2>4. Propriété intellectuelle</h2>
            <p>
              Tout le contenu de ce site, y compris les textes, images, logos et logiciels, est la propriété exclusive de FlxDeck. Il ne peut être copié, modifié ou distribué sans notre accord écrit
              préalable.
            </p>
          </section>

          <section className="policy__section">
            <h2>5. Limitation de responsabilité</h2>
            <p>FlxDeck ne pourra être tenu responsable des dommages indirects, incidents ou conséquences découlant de l’utilisation ou de l’impossibilité d’utiliser notre site ou nos services.</p>
          </section>

          <section className="policy__section">
            <h2>6. Politique de confidentialité</h2>
            <p>
              La protection de vos données est importante pour nous. FlxDeck ne collecte aucune donnée personnelle des membres de votre salle via la borne. Les utilisateurs n’ont jamais besoin de
              créer de compte, de s’inscrire ou de télécharger une application. Pour plus de détails sur le traitement des informations partenaires, veuillez consulter notre{" "}
              <a href="/politique-confidentialite">Politique de confidentialité</a>.
            </p>
          </section>

          <section className="policy__section">
            <h2>7. Modifications des conditions</h2>
            <p>Nous pouvons mettre à jour ces Conditions Générales d’Utilisation de temps à autre. Toute modification sera publiée sur cette page avec une date de mise à jour révisée.</p>
          </section>

          <section className="policy__section">
            <h2>8. Contact</h2>
            <p>
              Pour toute question concernant ces Conditions Générales d’Utilisation, veuillez nous contacter à l’adresse suivante : <a href="mailto:contact@flxdeck.com">contact@flxdeck.com</a>.
            </p>
          </section>
        </div>
      </main>
    </>
  );
};

export default ConditionsGenerales;
